import { ThemeProvider } from '@emotion/react';
import React, { ReactNode } from 'react';
import { THEME_TYPE, THEME } from 'theme';
const whiteLabel = window.WHITE_LABEL_CONFIG;

export const WhiteLabelContext = React.createContext(whiteLabel);

export const WhiteLabelProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <WhiteLabelContext.Provider value={whiteLabel}>
      <ThemeProvider theme={THEME as THEME_TYPE}>{children}</ThemeProvider>
    </WhiteLabelContext.Provider>
  );
};
